<script lang="ts">
import { setLabelledByAttribute } from '@/utils/utils'
import { defineComponent } from 'vue'

/**
 * A container to display an aside.
 */
export default defineComponent({
  props: {
    /**
     * The ID of the element that labels this aside.
     */
    labelledBy: {
      type: String,
      default: null,
    },
  },
  mounted() {
    setLabelledByAttribute(this.$el)
  },
})
</script>

<template>
  <aside
    class="relative mx-auto w-full max-w-screen-xl px-3 py-3 @md/main:px-8 @md/main:py-5 @xl/main:rounded-md"
    :aria-labelledby="labelledBy"
  >
    <slot />
  </aside>
</template>
